import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddonsComponent} from './addons/addons.component';
import {RouterModule} from '@angular/router';
import {EditAddonsComponent} from './edit-addons/edit-addons.component';
import {ShowAddonsComponent} from './show-addons/show-addons.component';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxDataDisplayModule} from "@allianz/ng-aquila/data-display";
import {PipeModule} from "../../pipe/pipe.module";


@NgModule({
  declarations: [
    AddonsComponent,
    EditAddonsComponent,
    ShowAddonsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NxCardModule,
    NxIconModule,
    ComponentsModule,
    NxHeadlineModule,
    NxGridModule,
    NxButtonModule,
    NxFormfieldModule,
    NxInputModule,
    FormsModule,
    NxDataDisplayModule,
    PipeModule,
  ]
})
export class AddonModule {
}
